// Transaction status
export const TRANSACTION_STATUS = {
  SUCCESS: 1,
  TIMEOUT: 2,
  PAYING: 3,
  FAILED: 4,
}

// Payment method Id
export const PAYMENT_METHOD_ID = {
  PAYPAL: 1,
  STRIPE: 2,
  NGANLUONG: 3,
  MOMO: 4,
  ADYEN: 5,
  PAYPAL_QR: 15,
  ONEPAY: 17,
  BANKING_VIETCOMBANK: 6,
  APPLE_PAY: 20,
  VIETQR: 1702,
}

// Transaction type
export const TRANSACTION_TYPE = {
  PROCESSING: 1,
  PROCESSED: 2,
}

// Status text
export const PAYMENT_STATUS_TEXT = {
  "1": "paymentStatus.success",
  "2": "paymentStatus.canceled",
  "3": "paymentStatus.incomplete",
  "4": "paymentStatus.failed",
}

// Style status text
export const PAYMENT_STYLE_STATUS_TEXT = {
  "1": "status-text-success",
  "2": "status-text-timeout",
  "3": "status-text-paying",
  "4": "status-text-failed",
}

// Style status text
export const PAYMENT_STATUS_ICON = {
  "1": "el-icon-check",
  "2": "el-icon-remove-outline",
  "3": "el-icon-time",
  "4": "el-icon-close",
}